const TOOLBAR_FILTER_WIDTH = 160;

export const toolbarFilterControlSx = {
  flex: `0 0 ${TOOLBAR_FILTER_WIDTH}px`,
  width: TOOLBAR_FILTER_WIDTH,
} as const;
